import * as React from 'react';
import { FilterTagProps } from '../../custom/components/filters/filter-tags';
import FilterTagView from './filter-tag.view';
import ClearAll from '../../components/filters/clear-all';

const FilterTags: React.StatelessComponent<FilterTagProps> = props => {

    return (
        <div className={`filter-tags-container ${props.eventFilters.length === 0 ? 'hide' : 'visible'}`}>
            <h2 className="visually-hidden">Selected filters</h2>
            {
                props.eventFilters.map(v => <FilterTagView {...props} filterKey={v.key} value={v.selectedValue} />)
            }
            <ClearAll />
        </div>
    );
}

export default FilterTags;